import BlockText from "../block-content/block-text";
import styled from "styled-components";
import tw from "twin.macro";
import Image from "gatsby-plugin-sanity-image";
import ButtonLink from "./button-link";
import { SchemaVideoObject } from "../schema-video-object";

const TextStyles = styled.div`
  a {
    ${tw`text-blue-500 cursor-pointer underline hover:text-blue-600`}
  }

  p {
    ${tw`text-base md:text-xl mb-6 md:leading-relaxed`}
  }
  ul {
    list-style-type: disc;
    list-style-position: inside;
  }
  ol {
    list-style-type: decimal;
    list-style-position: inside;
  }
  ul ul, ol ul {
    list-style-type: circle;
    list-style-position: inside;
    margin-left: 15px;
  }
  ol ol, ul ol {
    list-style-type: lower-latin;
    list-style-position: inside;
    margin-left: 15px;
  }
`;
const IntroBlock = ({ pageBlock, section }) => {
  return (
    <section
      className={`${
        pageBlock.videoID ? `py-8 md:py-24` : `text-blue-800 my-6 md:mt-16`
      }`}
    >
      <div
        className={`${pageBlock.videoID ? `max-w-7xl` : `max-w-6xl`} mx-auto`}
      >
        <div
          className={`${
            pageBlock.title ? `px-4 items-start ` : `px-4`
          } flex flex-wrap`}
        >
          {pageBlock.videoID && (
            <>
              <div className="w-full md:w-4/12 mb-6 md:pr-16 mr-auto">
                <p className="md:text-lg">
                  <BlockText blocks={pageBlock._rawBody} />
                </p>
              </div>
              <div className="w-full md:w-8/12 md:pr-4">
                <div className="embed-responsive aspect-ratio-16/9 shadow-2xl">
                  <iframe
                    title={"YouTube Video"}
                    src={`https://www.youtube.com/embed/${pageBlock.videoID.trim()}?rel=0`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen={``}
                  ></iframe>
                </div>
              </div>
              <SchemaVideoObject
                name={pageBlock.title}
                description={pageBlock?.metaDescription || ""}
                thumbnail={
                  pageBlock?.image?.asset?.url ||
                  `https://img.youtube.com/vi/${pageBlock?.videoID?.trim()}/maxresdefault.jpg`
                }
                embedUrl={`https://www.youtube.com/embed/${pageBlock?.videoID?.trim()}?rel=0`}
              />
            </>
          )}
          {pageBlock.title && (
            <>
              <div className="w-full md:w-5/12 md:pr-10">
                <h2 className="text-blue-500 font-bold tracking-tighter text-2xl md:text-4xl mb-4">
                  {pageBlock.title}
                </h2>
              </div>
              <div className="w-full md:w-7/12">
                <TextStyles>
                  <BlockText blocks={pageBlock._rawBody} />
                </TextStyles>
                <ButtonLink
                  label={pageBlock.buttonText}
                  link={pageBlock.link}
                />
              </div>
            </>
          )}
          {!pageBlock.title && !pageBlock.videoID && (
            <>
              <div className="w-full md:w-1/2">
                <TextStyles>
                  <BlockText blocks={pageBlock._rawBody} />
                </TextStyles>
                <ButtonLink
                  label={pageBlock.buttonText}
                  link={pageBlock.link}
                />
              </div>
              <div className="hidden md:flex md:w-1/2 md:pl-16">
                {pageBlock.image && pageBlock.image.asset && (
                  <Image
                    {...pageBlock.image}
                    width={496}
                    className="align-top object-cover md:h-full"
                    alt={pageBlock.image.alt || ``}
                  />
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default IntroBlock;
